module.exports = __webpack_public_path__ + "assets/img/00011.289be200.png";